import { Outlet, useLocation } from "react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Banner } from "~/features/core/Banner";
import { NavBar } from "~/features/public/NavBar";
import CaboLabLogo from "~/assets/logos/logo.svg";
import { PHARMACY_SEARCH_ENABLED } from "~/feature_flags";

export default function PharmacyHome() {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("start");

  const location = useLocation();
  const path = location.pathname.split("#")[0];
  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "start",
        "vorteile",
        "angebot",
        "ablauf",
        ...(PHARMACY_SEARCH_ENABLED ? ["apothekeFinden"] : []),
        "faq",
      ];
      const currentSection = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 150 && rect.bottom >= 150;
        }
        return false;
      });
      if (currentSection) {
        setActiveSection(currentSection);
      }
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [path]);

  const navItems = [
    { label: t("Start"), to: "/tests#start", id: "start" },
    { label: t("Vorteile"), to: "/tests#vorteile", id: "vorteile" },
    { label: t("Angebot"), to: "/tests/products", id: "angebot" },
    { label: t("Ablauf"), to: "/tests#ablauf", id: "ablauf" },
    ...(PHARMACY_SEARCH_ENABLED
      ? [{ label: t("Apotheke finden"), to: "/tests#apothekeFinden", id: "apothekeFinden" }]
      : []),
    { label: t("FAQ"), to: "/tests#faq", id: "faq" },
    { label: t("Testergebnis abrufen"), to: "https://mein.cabocheck.com", id: "testergebnis" },
  ];

  return (
    <div className="relative font-open-sans antialiased">
      <Banner />
      <NavBar
        activeSection={activeSection}
        logo={CaboLabLogo}
        logoTo={path === "/tests" ? "/" : "/tests"}
        navItems={navItems}
        sticky
      />
      <Outlet />
    </div>
  );
}
